export enum FlightType {
  DOMDOM = 'DOMDOM',
  DOMINT = 'DOMINT',
  INTDOM = 'INTDOM',
  INTINT = 'INTINT',
}
